module.exports = __webpack_public_path__ + "static/heroBG-7d528b0268510a49fbe9093015a7e573.png";